import Loading from 'quasar/src/plugins/loading/Loading.js';
import { defineComponent, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import BreadcrumbList from "~/components/BreadcrumbList.vue";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { HanyoKb, PageID, userType } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
import { myPageStore } from "~/store/MyPageStore";
import RoomSelectArea from "~/components/roomSelect/RoomSelectArea.vue";
const log = Log.create("ShomeiRoomSelect");
export default defineComponent({
    components: {
        RoomSelectArea,
        BreadcrumbList
    },
    name: "ShomeiRoomSelect",
    beforeRouteEnter(to, from, next) {
        if (!myPageStore.isMultipleKeiyaku) {
            next({ name: "shomei-precautions" });
            return;
        }
        next();
    },
    setup() {
        // 画面名取得
        const pageName = commonStore.pageName(PageID.shomeiRoomList);
        const router = useRouter();
        const isDialog = ref(false);
        //** 行・カード押下時のイベント */
        const onPush = (selectedNyukyokeiyakuNo) => {
            roomConfirm(selectedNyukyokeiyakuNo);
        };
        const roomConfirm = (selectedNyukyokeiyakuNo) => {
            try {
                myPageStore.selectedNyukyokeiyakuNo = selectedNyukyokeiyakuNo;
                router.push({ name: "shomei-precautions", query: { selectedNyukyokeiyakuNo: selectedNyukyokeiyakuNo } });
                Loading.show();
            }
            catch (ex) {
                log.error("roomConfirm", ex);
                MsgBox.error(ex.message);
            }
            finally {
                Loading.hide();
            }
        };
        return {
            ...toRefs(myPageStore),
            PageID,
            userType,
            HanyoKb,
            myPageStore,
            pageName,
            router,
            isDialog,
            onPush
        };
    }
});
